/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import cstmTable from '../../../share/components/vue/PaginationTable';
import config from '../../../share/config';
import apiService from '../../../share/util/api/service';
import { apiErrorDefaultAction } from "../../../share/util/api/errorAction";
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../share/util/api/polling';
import alert from '../../../share/alert';
import loading from '../../../share/components/vue/ProcessingIcon';
import memoPage from '../../vue/MemoPage';
import resource from '../../../share/util/resourceMap';
import vehicle from '../../../share/util/vehicle';
import util from '../../../share/util/utils';
import cstmCard from "../../../share/components/vue/CustomCard";
import eventLogUtil from '../../../share/util/eventLogUtil';
import constants from '../../../common/nodejs/constants';
import diagnoseResource from '../../../share/util/diagnose';
import { checkResCurrentSettingValue, getDestinationModalTitle, isShowInputForm, getDestinationHeaderColor, getDestinationMessage, readSetDestination, getMenuSupport, getMatchCondition, readDestinationSetting, getCurrentSettingValue, writeDestinationSetting, getWriteDestinationSetting, readSupportDid, isDestinationInputCodeValidate, checkDestinationCodeDetail, checkBIU } from './destinationServices';
import { ALL_CUSTOMIZE } from "../../../constants/usageCountTypes";
import { getUnexpectedErrorMessageKey, ALL_SYSTEMS, VEHICLE_INFO_GET, VEHICLE_DESTINATION_SAVE, DESTINATION_PHASE, TRANSITION, TABLE_COLUMNS_ALL_CUSTOMIZE, TABLE_COLUMNS_CUSTOMIZE_READ, VEHICLE_READ_HISTORY, VEHICLE_DELETE_HISTORY } from './constants.js';
import { initCustomize } from "./initializeServices.js";
import { readCustomizeTable, getCustomizeList, checkCstmListItem } from './settingsReadOutServices.js';
import { updateCustomizeTable, getRequestBodyUpdateSettings } from './settingsUpdateServices.js';
import { saveCustomizeHistories, getSaveSettingsRequestBody } from './historiesSaveServices.js';
import { searchCustomizeHistories, getInitializeSearchConditions } from './historiesGetServices.js';
import { vehicleFuncs } from './vehicleServices.js';
import { fetchMasterMirrorCustomizeHistories } from '../../../services/customize/fetchHistoriesService.js';
import { deleteCustomizeHistory } from '../../../services/customize/deleteHistoryService.js';

export default {
  name: "allCustomize",
  data() {
    return {
      processing: false,
      measuredId: null,
      cstmListItem: [],
      cstmDataResponse: null,
      isLoading: false,
      currentDate: null,
      vehicleDisplayInfo: {
        vin: '',
        specMode: '',
        spec: '',
        model: '',
        appliedModel: '',
        modelDisplayName: '',
        registrationNumber: '',
        hideRegistrationNumber: true,
      },
      description: '',
      customReadTable: [],
      customReadTablePre: [],
      selectedYear: '',
      selectedMonth: '',
      searchYearOptions: [''],
      searchMonthOptions: [''],
      filledComment: '',
      isSearchFieldOpened: true,
      selectedCustomRead: {},
      modalMemo: false,
      modalCustomRead: false,
      modalSettingsSave: false,
      isMemoDialogLoading: false,
      showSetDestination: false,
      destinationPhase: DESTINATION_PHASE.CONFIRMATION,
      validateParam: undefined,
      currentDestination: '',
      confirmationDestination: '',
      reconfirmationDestination: '',
      inputDestinationCode: '',
      tmpRequestId: '',
      vehicleRunStatus: null,
      destinationSystem: null,
      modalAlertCgwCecuNotCommunicated: false,
    };
  },

  props: {
    // noop
  },

  components: {
    'processing-view': loading,
    'cstm-table': cstmTable,
    'memo-Page': memoPage,
    'cstm-card': cstmCard
  },

  watch: {
    language: {
      handler(val) {
        val; // To avoid warning
        if (!this.cstmDataResponse) return;
        this.cstmListItem = resource.getAllCstmSaveOrderTable(this.cstmDataResponse, this.cstmListItem, this);
        // 設定保存・設定読み出しダイアログ_車両情報の取得
        this.getVehicleInfoForSaveSettings();
      }
    },

    /** 車両情報取得(診断)の状態監視 */
    async vehicleStatus(value) { vehicleFuncs.vehicleStatus.bind(this, value, async () => this.init(true))(); },
    /**車両情報取得(診断)ステータス状態監視 */
    async phase(value) { vehicleFuncs.phase.bind(this, value)(); },
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      vehicleModelDisplayNameList: state => state.masterResources.vehicleModelDisplayNameList,
      userInfo: state => state.userProperty.userInfo,
      multipleMenuList: state => state.vehicle.multipleMenus.menu_list,
      isDiagAvailable: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_DIAG],
      // 車種情報取得の接続状況
      vehicleStatus: state => state.vehicle.status,
      phase: state => state.vehicle.phase,
      vehicleError: state => state.vehicle.error,
      vehicleWatcher: state => state.vehicle.watcher,
      oldVehicleInfo: state => state.cache.vehicleInfo,
      isPopstateNavigation: state => state.cache.isPopstateNavigation,
    }),

    /**
     * システム名のリスト取得
     * @returns {string[]} システム名のリスト
     */
    systemList() {
      return this.multipleMenuList.reduce((acc, menu) => {
        if (menu.menu_display_config.customize) acc.push(menu.system_name);
        return acc;
      }, []);
    },

    /** カスタムテーブルのcolumn定義 */
    cstmTableColumns() { return TABLE_COLUMNS_ALL_CUSTOMIZE; },
    /** 設定読出しテーブルcolumn */
    customReadTableColumns() { return TABLE_COLUMNS_CUSTOMIZE_READ; },
    /** 診断系のAPIは複数画面から使用されているため 現在の画面で使用されるAPIが診断/データ再生/個別診断のうちどの機能なのか判別する */
    operationScreen() { return diagnoseResource.operationFrom(this.$router.currentRoute.value.name); },
    /** 仕向地設定モーダルのヘッダタイトル */
    destinationTitle() { return getDestinationModalTitle(this, this.destinationPhase); },
    /** 入力欄を表示するかどうか */
    showInputForm() { return isShowInputForm(this.destinationPhase); }
  },

  /**
   * 遷移してきた画面のパラメータ情報を保持
   * 同一コンポーネントが再帰的に利用された場合、呼び出される
   */
  beforeRouteUpdate(to, from, next) {
    if (this.isPopstateNavigation) {
      this.cacheIsPopstateNavigation(false);
      next();
      return;
    }
    this.$nextTick(() => {
      // テーブル情報クリア（本当は mountedLogic に入れたいが、影響範囲を考慮してここにピンポイントで入れている）
      this.cstmListItem = [];
      // mounted時に行う共通処理を呼び出す
      this.mountedLogic();
    });
    next();
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('table', ['getDtcSystemTable']),
    ...mapActions('observation', ['usageCountUp']),
    ...mapActions('vehicle', ['updateVehicleInfo', 'runSystemApi', 'getMultipleMenus', 'getIndividualMenus', 'continueSystemApi']),
    ...mapActions('cache', ['cacheFFDStores', 'cacheIsPopstateNavigation']),

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // 設定保存ダイアログ_車両情報の取得
      this.getVehicleInfoForSaveSettings();
      // カスタマイズテーブル一覧取得APIの呼び出し
      this.init();
      // 初期の検索条件の設定（現在の年、月）
      const conditions = getInitializeSearchConditions();
      this.selectedYear = conditions.selectedYear;
      this.searchYearOptions = conditions.searchYearOptions;
      this.selectedMonth = conditions.selectedMonth;
      this.searchMonthOptions = conditions.searchMonthOptions;
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result バリデーション結果
    * @param {string} action 処理内容
    */
    validateErrorResult(result, action) {
      apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(action); },
      );
    },

    /**
     * カスタマイズ一覧の取得を行う
     * @param {boolean} eventLogHandleIdFlg 再取得から呼ばれた際に true（イベントログの操作 ID 発行する）とする
     */
    async init(eventLogHandleIdFlg = false) {
      try {
        this.processing = true;
        if (this.systemList.length > 0) {
          // イベントログの操作 ID 発行
          await eventLogUtil.createEventLogHandleId(this.netAppId);
          // カスタマイズ一覧取得のポーリング処理を行う
          const response = await initCustomize(this, ALL_SYSTEMS, {
            use_cache: false,
            system_name: this.systemList
          });

          if (response) await this.checkDestinationSettingRead(eventLogHandleIdFlg);
        } else {
          // 対象システムがない場合は初期化通信APIを実行せず0件表示
          // 通常は対象システムがない場合全カスタマイズメニューが表示されないためフェールセーフ
          this.cstmListItem = [];
        }
      } finally {
        this.processing = false;
      }
    },

    /** メモダイアログを表示 */
    openNoteModal() { this.modalMemo = true; },
    /** メモダイアログを閉じる */
    closeNoteModal() { this.modalMemo = false; },
    /** メモ情報の保存 */
    async memoSave() { await this.$refs.memo.save(); },
    /** メモ情報のクリア */
    memoClear: function () { this.$refs.memo.clear(); },

    /**
     * 設定保存ボタン押下
     */
    onClickSaveSettings() {
      // 説明入力の初期化
      this.description = '';
      // ダイアログ表示タイミングで、現在日時を取得する
      this.currentDate = util.timeConverter(Date.now(), null, 'min');
      // 設定保存ダイアログの表示
      this.modalSettingsSave = true;
    },

    /**
     * 再取得ボタン押下時の処理
     * 全DTC画面の車両情報再取得処理と同じ処理を実施する
     */
    reGetCstm: async function () {
      const messages = this.$t('individual.message_vehicle_csmt_confirm_get_information');
      alert.showConfirmation(this, null,
        messages,
        async () => {
          // 車種情報の全取得
          this.processing = true;
          // リストを空にしておく
          this.cstmListItem = [];
          // 車両情報の再取得を実施する
          const data = {
            netAppId: this.netAppId,
            endPoint: '',
            execType: config.INQUIRY_TYPE_DTC,
            this: this,
            // isCreateProject: システムAPI実施前にプロジェクト作成APIを投げるか否かのフラグ
            options: { isCreateProject: false },
            type: apiService.DIAG
          };
          this.vehicleRunStatus = VEHICLE_INFO_GET;
          this.cacheFFDStores([]);
          this.updateVehicleInfo(data);
        });
    },

    /**
     * カスタマイズ設定変更ボタン活性化の有無
     */
    getChangedItemsCount() {
      return this.getChangedItems().length;
    },

    /** 
     * カスタマイズ設定変更ボタン活性化の有無 
     */
    getChangedItems() {
      return this.cstmListItem.filter(
        // 設定変更されたアイテムのみに絞る
        cstm => cstm.currentValue !== cstm.selectItem
      );
    },

    /** カスタマイズ設定変更ボタン押下時の処理 */
    updateCstmData() {
      const messages = this.$t('individual.message_confirm_cstm_change_setting');
      // 設定値変更確認ダイアログを表示
      alert.showConfirmation(this, null, messages,
        async () => {
          await this.cstmChangeSetting();
        });
    },

    /** カスタマイズの設定値変更を行う */
    async cstmChangeSetting() {
      try {
        // カスタマイズの設定値変更
        this.processing = true;
        // イベントログの操作 ID 発行
        await eventLogUtil.createEventLogHandleId(this.netAppId);
        // カスタマイズの設定値変更(要求)（バックエンドAPI_POST）
        const response = await updateCustomizeTable(this, ALL_SYSTEMS, getRequestBodyUpdateSettings(this.cstmListItem));

        if (response) {
          // 正常終了：一覧データ取得処理を行う
          this.measuredId = String(response.data.measured_id);
          await this.getCstmList();
        }
      } finally {
        this.processing = false;
      }
    },

    /**
     * カスタマイズの取得を行う関数
     * @param {boolean} eventLogHandleIdFlg 再取得から呼ばれた際に true（イベントログの操作 ID 発行する）とする
     */
    async getCstmsTable(eventLogHandleIdFlg = false) {
      try {
        this.processing = true;
        // イベントログの操作 ID 発行
        if (eventLogHandleIdFlg) await eventLogUtil.createEventLogHandleId(this.netAppId);
        // カスタマイズの取得(要求)
        const response = await readCustomizeTable(this, ALL_SYSTEMS, { system_name: this.systemList });

        if (response) {
          // 正常終了：一覧データ取得処理を行う
          this.measuredId = String(response.data.measured_id);
          await this.getCstmList();
          // カスタマイズの利用回数カウントアップ
          this.usageCountUp({ type: ALL_CUSTOMIZE });
        }
      } finally {
        this.processing = false;
      }
    },

    /**
    * 一覧取得処理を行う関数
    */
    async getCstmList() {
      const projectId = this.vehicleInfo.vehicle.project.id;
      // Get APIを呼び出す
      const response = await getCustomizeList(this, projectId, this.measuredId);
      // 処理失敗時は response が null になるので考慮
      if (response !== null) {
        this.cstmDataResponse = response.data;
        this.cstmListItem = resource.getAllCstmSaveOrderTable(this.cstmDataResponse, this.cstmListItem, this);
        // カスタマイズの返却値が空でもエラーにしない
        // エラーチェック
        const errorType = checkCstmListItem(this.cstmListItem);
        if (errorType) {
          this.showUnexpectedError(errorType);
        } else {
          // 表示項目がない場合、非サポート画面を表示
          if (this.cstmListItem.length < 1) {
            // OK押下時は何もしない
            alert.showConfirmation(this, null, this.$t('individual.label_not_supported_message'), null, null, null, true);
          }
        }
      }
    },

    /**
    * その他のエラー発生時の処理を行う
    * @param {string} action 処理内容
    */
    showUnexpectedError(action) {
      // messageKeyは必ず一致があるものとする
      alert.showError(this, null, this.$t(getUnexpectedErrorMessageKey(action)), () => { });
    },

    /**
     * 設定保存ダイアログ_車両情報の取得
     */
    getVehicleInfoForSaveSettings() {
      // 車両情報の取得
      this.vehicleDisplayInfo = vehicle.formatVehicleInfo(this.vehicleInfo, this.vehicleModelDisplayNameList, this.language);
    },

    /**
     * 設定保存ダイアログ_保存ボタン押下
     */
    async saveSettings() {
      // 設定保存処理
      await this.createSaveSettings();
      // ダイアログを閉じる
      this.modalSettingsSave = false;
    },

    /**
     * 設定保存処理
     */
    async createSaveSettings() {
      try {
        this.isLoading = true;
        await saveCustomizeHistories(this, ALL_SYSTEMS, {
          description: this.description.trim(),
          setting: getSaveSettingsRequestBody(this.cstmListItem)
        });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 設定保存ダイアログ_キャンセルボタン押下
     */
    cancelSaveSettings() {
      // ダイアログを閉じる
      this.modalSettingsSave = false;
    },

    /** 読み出し中ダイアログの表示 */
    showCustomReadModal() {
      this.modalCustomRead = true;
      // 設定読み出し一覧を取得
      this.showCustomReadList();
    },

    /** 検索の実行 */
    searchCustom() {
      // 選択中の解除
      this.selectedCustomRead = {};
      this.setHighLight();

      // 検索入力値の取得
      const comment = this.filledComment.trim();
      // 検索条件でフィルター処理
      this.customReadTable = searchCustomizeHistories(this.customReadTablePre, this.selectedYear, this.selectedMonth, comment);
    },

    /** 
     * 設定一覧取得 
     */
    async showCustomReadList() {
      try {
        this.processing = true;

        // 設定読み出し一覧をマスター・ミラー両方から取得
        const { customizeHistories, validateErrorResult, hasUnexpectedError } =
          await fetchMasterMirrorCustomizeHistories(
            this,
            this.netAppId,
            ALL_SYSTEMS,
          );
        if (validateErrorResult) {
          this.validateErrorResult(validateErrorResult, VEHICLE_READ_HISTORY);
        } else if (hasUnexpectedError) {
          this.showUnexpectedError(VEHICLE_READ_HISTORY);
        }

        if (customizeHistories?.length > 0) {
          // 成功有無に関わらず、結果が得られた場合はテーブルデータを更新する
          customizeHistories.forEach((cstm) => {
            // unix時刻を文字列に変換する
            cstm.registered_at = util.timeConverter(cstm.registered_at);
            // 削除ボタンを設定する
            cstm.buttonVisible = true;
          });
          this.customReadTable = customizeHistories;
          this.customReadTablePre = this.customReadTable;
          this.searchCustom();
        }
      } finally {
        this.processing = false;
      }
    },

    /** 行選択 */
    clickRow(selected) {
      this.selectedCustomRead = selected;
      this.setHighLight();
    },

    /** 選択している機能のハイライト設定 */
    setHighLight() {
      this.customReadTable.forEach((item) => {
        if (item === this.selectedCustomRead) {
          item.fieldSpec = {
            registered_at: config.LIST_ITEM_HIGHLIGHT,
            description: config.LIST_ITEM_HIGHLIGHT,
          };
        } else if (item.fieldSpec) {
          delete item.fieldSpec;
        }
      });
    },

    /**
     * 削除ボタン押下処理
     * @param {object} selected 選択されている設定値
     */
    async delCustomReadList(selected) {
      try {
        this.processing = true;

        const { validateErrorResult, hasUnexpectedError } =
          await deleteCustomizeHistory(
            this,
            this.netAppId,
            ALL_SYSTEMS,
            selected.id,
            selected.region_info,
          );
        if (validateErrorResult) {
          this.validateErrorResult(validateErrorResult, VEHICLE_DELETE_HISTORY);
        } else if (hasUnexpectedError) {
          this.showUnexpectedError(VEHICLE_DELETE_HISTORY);
        } else {
          // 正常終了の場合、再読み込みで削除せず、表示上削除することで、APIを呼び出す手間を省く
          this.customReadTable = this.customReadTable.filter(
            (item) => item !== selected,
          );
          this.customReadTablePre = this.customReadTable;

          // 選択中の行が削除された場合、選択状態を解除する
          if (selected === this.selectedCustomRead) {
            this.selectedCustomRead = {};
          }
        }
      } finally {
        this.processing = false;
      }
    },

    /** 読み出し中ダイアログ_キャンセルボタン押下 */
    cstmReadClose() {
      // 読み出し中ダイアログを閉じる
      this.modalCustomRead = false;
    },

    /** 読み出し中ダイアログ_読み出しボタン押下 */
    updCustomData() {
      const failedReadSettingNames = [];
      // 読み出し設定値の更新
      this.selectedCustomRead.settings.forEach(function (setting) {
        for (let count = 0; setting.setting.length > count; count++) {
          const targetItem = this.cstmListItem.find(item => item.immuTableId === setting.setting[count].immutable_id && item.systemId === setting.system_name);
          if (!targetItem) {
            // サポートされておらず保存された項目が非表示のケースがある。その場合は、反映をスキップする。
            continue;
          }
          const settingValue = resource.convertCstmDisplayItemNoDefault(targetItem.did, setting.setting[count].updateValue, setting.system_name, this);
          if (settingValue === '') {
            // 値が見つからない場合（新バージョンのマスターで保存された設定値が旧バージョンのミラーにない等）は、失敗一覧に記憶する
            failedReadSettingNames.push(targetItem.name);
          } else {
            targetItem.selectItem = settingValue;
          }
        }
      }, this);
      this.modalCustomRead = false;

      if (failedReadSettingNames.length > 0) {
        // 失敗一覧に項目がある場合のみ、ダイアログを表示する
        const failedSettingNames = [...new Set(failedReadSettingNames)].join('<br/>');
        const warningMessage = this.$t('individual.alert_cstm_read_settings_missing_values', [failedSettingNames]);
        alert.showWarning(this, null, warningMessage, () => { });
      }
    },

    /** 仕向地設定モーダルのヘッダカラー */
    destinationHeaderColor() { return getDestinationHeaderColor(this.destinationPhase); },
    /** 仕向地設定モーダルの表示文言 */
    destinationMessage() { return getDestinationMessage(this, this.confirmationDestination, this.reconfirmationDestination, this.destinationPhase); },

    /**
     * 次処理を実行 仕向地設定処理 (メニューサポート呼び出し～データ読出し)が必要あるかを判定し次処理を決定
     * @param {boolean} eventLogHandleIdFlg 再取得から呼ばれた際に true（イベントログの操作 ID 発行する）とする
     */
    async checkDestinationSettingRead(eventLogHandleIdFlg = false) {
      // ECUにボディコントロールユニット（BIU）が含まれるかチェック
      const biu = checkBIU(this.systemList);
      if (biu) {
        this.destinationSystem = biu;
        await this.destinationSettingRead();
      } else {
        // カスタマイズの取得を行う
        await this.getCstmsTable(eventLogHandleIdFlg);
      }
    },

    /**
     * 仕向地設定処理 (メニューサポート呼び出し～データ読出し)
     */
    async destinationSettingRead() {
      try {
        this.processing = true;
        this.isLoading = true;
        this.measuredId = null;

        // メニューサポート読出し
        const resMenuSupport = await this.postMenuSupport(this.destinationSystem);
        if (resMenuSupport.status === null) return;
        if (resMenuSupport.isFailed) {
          // 異常終了している ⇒ アラートを表示してカスタマイズ情報を取得する
          alert.showError(this, null, this.$t('individual.error_cstm_destination_get'), () => { this.getCstmsTable(); });
          return;
        }
        if (!resMenuSupport.status) {
          // 条件と一致していない ⇒ カスタマイズ情報を取得する
          await this.getCstmsTable();
          return;
        }

        // データ読出し
        const readCondition = await this.postReadDestinationSetting(this.destinationSystem);
        if (readCondition.status === null) return;
        if (readCondition.status) {
          // 指定された遷移を行う
          switch (readCondition.transition) {
            case TRANSITION.TRANSITION_CONFIRMATION:
              // データ読出しで取得したデータに応じて表示内容設定
              this.currentDestination = readSetDestination(readCondition.destination, this.destinationSystem, this);
              // 仕向地変更確認画面の表示内容を設定
              this.confirmationDestination = this.$t('individual.label_cst_current_destination').replace('$DID$', this.currentDestination);
              // 仕向地変更再確認画面の表示内容を設定
              this.reconfirmationDestination = this.$t('individual.label_cst_incorrect_destination').replace('$DID$', this.currentDestination);
              break;
            case TRANSITION.TRANSITION_GET_INFORMATION:
            default:
              // カスタマイズの取得を行う
              await this.getCstmsTable();
              return;
          }
        } else {
          // アラートを表示してカスタマイズ情報を取得する
          alert.showError(this, null, this.$t('individual.error_cstm_destination_get'), async () => { await this.getCstmsTable(); });
          return;
        }
        // 設定値が取得できたら仕向地変更確認画面を表示
        this.showSetDestination = true;
      } finally {
        this.processing = false;
        this.isLoading = false;
      }
    },

    /**
     * 仕向地設定処理 (データ書込み～サポートDID読出し)
     */
    async destinationSettingUpdate() {
      try {
        this.isLoading = true;
        this.measuredId = null;

        // データ書込み
        const updateCondition = await this.postWriteDestinationSetting(this.destinationSystem);
        if (updateCondition === null) return;
        if (!updateCondition) {
          this.showUnexpectedError(VEHICLE_DESTINATION_SAVE);
          return;
        }
        // サポートDID読出し
        if (!await readSupportDid(this, this.destinationSystem)) return;
        // カスタマイズ情報取得中画面に遷移
        // ※カスタマイズデータ取得処理を実行
        this.getCstmsTable();
      } finally {
        this.isLoading = false;
        // サポートDID読出しが完了したらモーダルを非表示にする
        this.showSetDestination = false;
        // 初期値を設定しておく
        this.destinationPhase = DESTINATION_PHASE.CONFIRMATION;
        this.inputDestinationCode = '';
        this.tmpRequestId = '';
      }
    },

    /**
     * メニューサポートを取得する
     * @param {string} systemId 現在のECU名
     * @returns {object} getMatchCondition()の返却値
     */
    async postMenuSupport(systemId) {
      // カスタマイズの取得(要求)（バックエンドAPI_POST）
      const response = await getMenuSupport(this, systemId);
      if (response) return await this.getMatchCondition(systemId);
      return { status: null };
    },

    /**
     * [UI.EXE.CST.RD.BIU.1]の実行条件を満たしているか確認する
     * @param {string} systemId 現在のECU名
     * @returns {object} 判定結果
     * @property {boolean} isFailed CC結果が異常終了している場合はtrue
     * @property {boolean} status [UI.EXE.CST.RD.BIU.1]の実行条件を満たしている場合はtrue
     */
    async getMatchCondition(systemId) {
      // Get APIを呼び出す
      const response = await getMatchCondition(this, systemId, this.tmpRequestId);
      const res = { status: null };
      if (response) {
        res.status = response.data.match_result;
        res.isFailed = !(response.data.status === REQUEST_STATUS_COMPLETED);
      }
      return res;
    },

    /**
     * 仕向地設定の現在設定値を取得
     * @param {string} systemId 現在のECU名
     * @returns {object} res
     * @property {boolean} status 処理が成功しているか
     * @property {string} transition 次の処理画面
     * @property {string} destination 現在の仕向地
     */
    async postReadDestinationSetting(systemId) {
      // カスタマイズの取得(要求)（バックエンドAPI_POST）
      const response = await readDestinationSetting(this, systemId);
      if (response) {
        // Get APIを呼び出す
        const response = await getCurrentSettingValue(this, systemId, this.tmpRequestId);
        return checkResCurrentSettingValue(response);
      }
      return { status: null };
    },

    /**
     * 入力した仕向地コードを書き込む
     * @param {string} systemId 現在のECU名
     * @returns {boolean} getWriteDestinationSetting()の返却値
     */
    async postWriteDestinationSetting(systemId) {
      // カスタマイズの取得(要求)（バックエンドAPI_POST）
      const response = await writeDestinationSetting(this, systemId, this.inputDestinationCode);
      let res = null;
      if (response) res = await this.getWriteDestinationSetting(systemId);
      return res;
    },

    /**
     * 仕向地設定の現在設定値を更新
     * @param {string} systemId 現在のECU名
     * @returns {boolean} 処理成功している場合は true を返却する
     */
    async getWriteDestinationSetting(systemId) {
      // Get APIを呼び出す
      const response = await getWriteDestinationSetting(this, systemId, this.tmpRequestId);
      if (response) {
        if (response.data.status === REQUEST_STATUS_COMPLETED) return true;
        if (response.data.status === REQUEST_STATUS_FAILED) return false;
      }
      return null;
    },

    /** 仕向地変更確認画面にてOK押下時の処理 */
    onDestinationConfirmationOkClicked() {
      // 仕向地コード入力画面に遷移
      this.destinationPhase = DESTINATION_PHASE.INPUT_CODE;
    },

    /** 仕向地コード入力画面にてOK押下時の処理 */
    onDestinationInputOkClicked() {
      // 入力内容が入力制限を満たしているか確認する
      if (this.isDestinationInputCodeValidate()) {
        // 入力制限を満たしていたら入力内容をチェックする
        // 1文字目のチェック (1文字目が英字)ではない または 2文字未満
        if (checkDestinationCodeDetail(this.inputDestinationCode)) {
          this.inputDestinationCode = '';
          // 仕向地変更再確認画面に遷移
          this.destinationPhase = DESTINATION_PHASE.RECONFIRMATION;
        } else {
          // 入力された内容で設定値を更新する
          this.destinationSettingUpdate();
        }
      }
    },

    /** 仕向地設定にてOK押下時の処理 */
    onDestinationSettingOkClicked() {
      switch (this.destinationPhase) {
        case 'confirmation':
        case 'reconfirmation':
          this.onDestinationConfirmationOkClicked();
          break;
        case 'inputCode':
          this.onDestinationInputOkClicked();
          break;
        default:
          break;
      }
    },

    /** 仕向地設定中にてキャンセル押下時 */
    onDestinationSettingCancelClicked() {
      // モーダル非表示
      this.showSetDestination = false;
      // 初期値を設定しておく
      this.destinationPhase = DESTINATION_PHASE.CONFIRMATION;
      this.inputDestinationCode = '';
      this.tmpRequestId = '';
      // カスタマイズ情報取得中画面に遷移
      // ※カスタマイズデータ取得処理を実行
      this.getCstmsTable();
    },

    /**
     * 入力内容が入力制限を満たしているか確認する
     * @returns {boolean} 検証結果 満たしているならtrue
     */
    isDestinationInputCodeValidate() {
      this.validateParam = isDestinationInputCodeValidate(this, this.inputDestinationCode);
      return this.validateParam === undefined;
    },

    /** 車両通信ポーリングの再開処理（OBFCM取得しない）*/
    async getObfcmToVehicle() { await vehicleFuncs.getObfcmToVehicle.bind(this)(); },
    /** CGW/C-ECU通信無し警告ダイアログからの車両通信ポーリングの再開処理 */
    async restartConnectionToVehicle() { await vehicleFuncs.restartConnectionToVehicle.bind(this)(); },
    /** CGW/C-ECU通信無し警告ダイアログのキャンセルイベント */
    closeCGwNotConnectModal() {
      this.$stopInterval(this.vehicleWatcher);
      this.modalAlertCgwCecuNotCommunicated = false;
    },
  },

  /**
   * createdイベント
   */
  created() {
    // イベントログのページビューカウント
    eventLogUtil.eventLogPageViewCount(constants.EVENT_LOG_PAGE_VIEW_PAGE_NAME_INDIVIDUAL_CST);
  },

  /**
   * mountedイベント
   */
  mounted() {
    this.mountedLogic();
  }
};